import React, {useState} from "react";
import IconChevronDown from '../../assets/icons/chevron-down.svg?react';
import IconCheck from '../../assets/icons/check.svg?react';

type FilterOption = {
    value: string
    label: string
    icon?: React.ReactNode
}

type FilterDropdownProps = {
    label: string
    options: FilterOption[]
    selected: string[]
    onChange: (values: string[]) => void
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({label, options, selected, onChange}) => {
    const [open, setOpen] = useState(false)

    const toggle = (value: string) => {
        onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value])
    }

    return (
        <div className="relative">
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className={`flex items-center gap-1.5 h-[34px] px-3.5 rounded-full border text-[13px] whitespace-nowrap ${
                    selected.length > 0
                        ? 'bg-neutralBlack-900 border-neutralBlack-900 text-white'
                        : 'bg-white border-neutralBlack-200 text-neutralBlack-800 hover:bg-neutralBlack-50'
                }`}
            >
                {label}
                {selected.length > 0 && <span className="opacity-80">· {selected.length}</span>}
                <IconChevronDown className={`w-2.5 h-2.5 transition-transform duration-200 ${selected.length > 0 ? 'text-white/70' : 'text-neutralBlack-500'} ${open ? 'rotate-180' : ''}`}/>
            </button>

            {open && (
                <>
                    <button type="button" aria-label="close" className="fixed inset-0 z-40 cursor-default" onClick={() => setOpen(false)}/>
                    <div className="absolute top-[42px] left-0 z-50 w-[220px] bg-white border border-neutralBlack-200 rounded-2xl shadow-lg p-1.5 flex flex-col gap-px">
                        {options.map((option) => {
                            const isSelected = selected.includes(option.value)
                            return (
                                <button
                                    type="button"
                                    key={option.value}
                                    onClick={() => toggle(option.value)}
                                    className="flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-[13.5px] text-neutralBlack-900 hover:bg-neutralBlack-100"
                                >
                                    <span className={`w-4 h-4 flex-none rounded-[5px] border flex items-center justify-center ${isSelected ? 'bg-neutralBlack-900 border-neutralBlack-900' : 'border-neutralBlack-300'}`}>
                                        {isSelected && <IconCheck className="w-2.5 h-2.5 text-white"/>}
                                    </span>
                                    {option.icon}
                                    <span className="flex-1 min-w-0 text-left truncate">{option.label}</span>
                                </button>
                            )
                        })}
                        {selected.length > 0 && (
                            <button
                                type="button"
                                onClick={() => onChange([])}
                                className="mt-1 pt-2 px-2.5 border-t border-neutralBlack-200 text-left text-[12.5px] text-neutralBlack-500 hover:text-neutralBlack-900"
                            >
                                Limpiar
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}
